/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLcm } from '../../factoriesAny.js';
export var lcmDependencies = {
  equalScalarDependencies,
  matrixDependencies,
  typedDependencies,
  createLcm
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLcm.generated.js
// module id = 1394
// module chunks = 2